// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { IconProps, Spacing } from '@iheartjane/reefer';
import { StarFilledIcon, StarIcon } from '@iheartjane/reefer';
import { useMemo } from 'react';

export interface OrderRatingStarProps {
  count?: number;
  index: number;
  isFilled?: boolean;
  isMobile?: boolean;
  onRatingPress: (index: number) => void;
  rating: number;
}

const StarEmpty = styled(StarIcon)(({ theme }) => ({
  opacity: 0.2,

  color: theme.colors.text.info,
  path: {
    fill: 'currentcolor',
  },
}));

export const OrderRatingStar = ({
  count = 0,
  index,
  isFilled = false,
  isMobile = false,
  onRatingPress,
  rating,
}: OrderRatingStarProps) => {
  const Icon = isFilled ? StarFilledIcon : StarEmpty;
  const [size, mr]: [Required<IconProps['size']>, Spacing] = useMemo(() => {
    const baseMr = isMobile ? 8 : 20;

    return [
      isMobile ? 'xl' : 'xxxl',
      (isFilled && index === 4) || (!isFilled && index === count - 1)
        ? 0
        : baseMr,
    ];
  }, [count, index, isFilled, isMobile]);

  return (
    <Icon
      altText={`Rate ${index + 1} out of 5 stars`}
      color={isFilled ? 'text-info' : undefined}
      key={index}
      mr={mr}
      // Assumes only empty stars can be selected once.
      onClick={isFilled || rating ? undefined : () => onRatingPress(index)}
      size={size}
    />
  );
};
